import {createApiClient} from "@codeages-private/qingjs-vue-skeleton-base";
import {useAuthStore} from "@/stores/useAuthStore";

export const appApiClient = createApiClient(`${import.meta.env.VITE_API_SERVER ?? ''}/api-app`, useAuthStore);

export const appAuthApiClient = createApiClient(`${import.meta.env.VITE_API_SERVER ?? ''}/api-app`, null);
